
const HeaderData = (jwtTokenJobcritic) => [
    {
        title: jwtTokenJobcritic ? '' : 'Home',
        link: jwtTokenJobcritic ? '' : '/'
        // title: 'Home',
        // link: jwtTokenJobcritic ? '/feeds' : '/'
    },
    // {
    //     title: jwtTokenJobcritic ? 'Profile' : '',
    //     link: jwtTokenJobcritic ? '/profile' : ''
    // },
    {
        title: jwtTokenJobcritic ? 'Verifications   ' : '',
        link: jwtTokenJobcritic ? '/verifications' : ''
    },
    // {
    //     title: 'Features',
    //     link: '/'
    // }
];

export default HeaderData;
